var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnEftToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 24,
    viewBox: "0 0 98 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H98L85.9649 8.53333L85.2551 11.6038C83.5775 18.8606 77.1144 24 69.6662 24H28.3338C20.8856 24 14.4225 18.8606 12.7449 11.6038L12.0351 8.53333L0 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2803 18.2803C53.9874 18.5732 53.5126 18.5732 53.2197 18.2803L48.75 13.8107L44.2803 18.2803C43.9874 18.5732 43.5126 18.5732 43.2197 18.2803C42.9268 17.9874 42.9268 17.5126 43.2197 17.2197L48.2197 12.2197C48.3603 12.079 48.5511 12 48.75 12C48.9489 12 49.1397 12.079 49.2803 12.2197L54.2803 17.2197C54.5732 17.5126 54.5732 17.9874 54.2803 18.2803Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnEftToggle);
export default __webpack_public_path__ + "static/media/btn_eft_toggle.5ed1bb91273e05ba4a4c625dea1c3e4b.svg";
export { ForwardRef as ReactComponent };